"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var react_socks_1 = __importDefault(require("react-socks"));

var ksys_app_template_1 = require("@kurtosys/ksys-app-template");

var mobx_react_1 = require("mobx-react");

var shared_1 = require("../../../shared");

var Wrapper_1 = __importDefault(require("./styledComponents/Wrapper"));

var ComponentWrapper_1 = __importDefault(require("./styledComponents/ComponentWrapper"));

var Components_1 = __importDefault(require("./styledComponents/Components"));

var Dots_1 = __importDefault(require("./styledComponents/Dots"));

var DotWrapper_1 = __importDefault(require("./styledComponents/DotWrapper"));

var Dot_1 = __importDefault(require("./styledComponents/Dot"));

var NavWrapper_1 = __importDefault(require("./styledComponents/NavWrapper"));

var Content_1 = __importDefault(require("./styledComponents/Content"));

var Nav_1 = __importDefault(require("./styledComponents/Nav"));

var Carousel_meta_1 = require("./Carousel.meta");

var mobx_1 = require("mobx");

var CarouselComponent =
/** @class */
function (_super) {
  __extends(CarouselComponent, _super);

  function CarouselComponent(props) {
    var _this = _super.call(this, props) || this;

    _this.categoryKey = Carousel_meta_1.CAROUSEL_CATEGORY_KEY;
    _this.componentKey = Carousel_meta_1.CAROUSEL_COMPONENT_KEY;
    _this.isAutoPlayEnabled = true;

    _this.handleDotClick = function (index) {
      _this.disabledAutoPlay();

      _this.changeIndex(index);
    };

    _this.changeIndex = function (index) {
      var currentIndex = _this.state.currentIndex;
      var componentCount = _this.componentCount;
      var newIndex = Math.min(componentCount - 1, Math.max(0, index));

      if (currentIndex !== newIndex) {
        _this.setAutoPlay();

        _this.setState({
          currentIndex: index
        });
      }
    };

    _this.moveFromIndex = function (offset) {
      var _a = _this.props.infiniteScroll,
          infiniteScroll = _a === void 0 ? false : _a;
      var currentIndex = _this.state.currentIndex;
      var adjustedIndex = (currentIndex || 0) + offset;

      if (adjustedIndex < 0) {
        if (!infiniteScroll) {
          return;
        }

        adjustedIndex = _this.pageCount - 1;
      }

      if (adjustedIndex > _this.pageCount - 1) {
        if (!infiniteScroll) {
          return;
        }

        adjustedIndex = 0;
      }

      _this.changeIndex(adjustedIndex);
    };

    _this.setAutoPlay = function () {
      var autoPlayInterval = _this.props.autoPlayInterval;

      if (_this.autoPlayId) {
        clearInterval(_this.autoPlayId);
      }

      var componentCount = _this.componentCount;

      if (autoPlayInterval && componentCount > 1 && _this.isAutoPlayEnabled) {
        _this.autoPlayId = setInterval(function () {
          return _this.moveFromIndex(1);
        }, autoPlayInterval);
      }
    };

    _this.handleNavClick = function (offset) {
      _this.disabledAutoPlay();

      _this.moveFromIndex(offset);
    };

    _this.enabledAutoPlay = function () {
      _this.isAutoPlayEnabled = true;

      _this.setAutoPlay();
    };

    _this.disabledAutoPlay = function () {
      _this.isAutoPlayEnabled = false;

      _this.setAutoPlay();
    };

    _this.state = {
      currentIndex: props.currentIndex || 0
    };

    _this.setAutoPlay();

    return _this;
  }

  CarouselComponent.prototype.componentWillUnmount = function () {
    clearInterval(this.autoPlayId);
  };

  Object.defineProperty(CarouselComponent.prototype, "componentsToShow", {
    get: function get() {
      var _a = this.props.componentsToShow,
          componentsToShow = _a === void 0 ? 1 : _a;
      return componentsToShow > 0 ? componentsToShow : 1;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(CarouselComponent.prototype, "pageCount", {
    get: function get() {
      return Math.ceil(this.componentCount / this.componentsToShow);
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(CarouselComponent.prototype, "currentIndex", {
    get: function get() {
      return this.state.currentIndex || 0;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(CarouselComponent.prototype, "childComponentArray", {
    get: function get() {
      var children = this.props.children;
      return react_1.default.Children.toArray(children) || [];
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(CarouselComponent.prototype, "currentComponents", {
    get: function get() {
      var _this = this;

      var childComponentArray = this.childComponentArray;

      if (ksys_app_template_1.utils.typeChecks.isNullOrEmpty(childComponentArray)) {
        return null;
      }

      var pagedComponents = [];

      for (var index = 0; index < this.componentCount; index += this.componentsToShow) {
        pagedComponents.push(childComponentArray.slice(index, index + this.componentsToShow));
      }

      return pagedComponents.map(function (page, pageIndex) {
        var componentStyle = {
          transform: "translate3d(" + -100 * _this.currentIndex + "%, 0, 0)",
          flex: {
            basis: "100%",
            shrink: '0'
          }
        };
        return react_1.default.createElement(ComponentWrapper_1.default, {
          componentStyle: componentStyle,
          key: pageIndex
        }, page);
      });
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(CarouselComponent.prototype, "componentCount", {
    get: function get() {
      return this.childComponentArray.length;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(CarouselComponent.prototype, "showNavigation", {
    get: function get() {
      var _a = this.props.navigationHidesWhenSingle,
          navigationHidesWhenSingle = _a === void 0 ? false : _a;
      return this.pageCount > 1 || !navigationHidesWhenSingle;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(CarouselComponent.prototype, "showLeftNavigation", {
    get: function get() {
      var _a = this.props.infiniteScroll,
          infiniteScroll = _a === void 0 ? true : _a;

      if (this.showNavigation) {
        return infiniteScroll || this.currentIndex !== 0;
      }

      return false;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(CarouselComponent.prototype, "showRightNavigation", {
    get: function get() {
      var _a = this.props.infiniteScroll,
          infiniteScroll = _a === void 0 ? true : _a;

      if (this.showNavigation) {
        return infiniteScroll || this.currentIndex + 1 < this.pageCount;
      }

      return false;
    },
    enumerable: true,
    configurable: true
  });

  CarouselComponent.prototype.isDotSelected = function (index) {
    return index === this.currentIndex;
  };

  CarouselComponent.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        className = _a.className,
        dotChildren = _a.dotChildren,
        navLeftChildren = _a.navLeftChildren,
        navRightChildren = _a.navRightChildren,
        _b = _a.hideDots,
        hideDots = _b === void 0 ? false : _b;
    var dotList = Array(this.pageCount).fill('');
    return react_1.default.createElement(Wrapper_1.default, {
      className: className,
      onMouseEnter: function onMouseEnter() {
        return _this.disabledAutoPlay();
      },
      onMouseLeave: function onMouseLeave() {
        return _this.enabledAutoPlay();
      }
    }, react_1.default.createElement(Content_1.default, null, this.showLeftNavigation && react_1.default.createElement(NavWrapper_1.default, {
      onClick: function onClick() {
        return _this.handleNavClick(-1);
      }
    }, react_1.default.createElement(Nav_1.default, {
      navIcon: 'base.carousel.navLeft'
    }, navLeftChildren || react_1.default.createElement("span", null, "<"))), react_1.default.createElement(Components_1.default, {
      componentStyle: {
        display: 'flex',
        width: '100%',
        overflow: {
          _value: 'hidden'
        }
      }
    }, this.currentComponents), this.showRightNavigation && react_1.default.createElement(NavWrapper_1.default, {
      onClick: function onClick() {
        return _this.handleNavClick(1);
      }
    }, react_1.default.createElement(Nav_1.default, {
      navIcon: 'base.carousel.navRight'
    }, navRightChildren || react_1.default.createElement("span", null, ">")))), !hideDots && this.showNavigation && react_1.default.createElement(Dots_1.default, null, dotList.map(function (e, index) {
      return react_1.default.createElement(DotWrapper_1.default, {
        key: "dot_" + index
      }, react_1.default.createElement(Dot_1.default, {
        selected: _this.isDotSelected(index),
        onClick: function onClick() {
          return _this.handleDotClick(index);
        },
        dot: 'base.carousel.dot',
        dotSelected: 'base.carousel.dotSelected'
      }, dotChildren));
    })));
  };

  CarouselComponent.defaultProps = {
    currentIndex: 0
  };

  __decorate([mobx_1.computed], CarouselComponent.prototype, "componentsToShow", null);

  __decorate([mobx_1.computed], CarouselComponent.prototype, "pageCount", null);

  CarouselComponent = __decorate([mobx_react_1.observer], CarouselComponent);
  return CarouselComponent;
}(shared_1.ComponentBase);

var Carousel =
/** @class */
function (_super) {
  __extends(Carousel, _super);

  function Carousel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.categoryKey = Carousel_meta_1.CAROUSEL_CATEGORY_KEY;
    _this.componentKey = Carousel_meta_1.CAROUSEL_COMPONENT_KEY;
    return _this;
  }

  Carousel.prototype.render = function () {
    var _this = this;

    var breakpoints = this.breakpoints;

    if (breakpoints) {
      return react_1.default.createElement(react_1.Fragment, null, breakpoints.map(function (breakpoint, breakpointIndex) {
        var props = ksys_app_template_1.utils.object.deepMergeObjectsWithOptions({
          arrayMergeStrategy: 'DeepMerge'
        }, _this.props, breakpoint.props);

        var breakpointProps = _this.getBreakpointComponentProps(breakpoint, breakpointIndex);

        return react_1.default.createElement(react_socks_1.default, __assign({}, breakpointProps), react_1.default.createElement(CarouselComponent, __assign({}, props)));
      }));
    }

    return react_1.default.createElement(CarouselComponent, __assign({}, this.props));
  };

  return Carousel;
}(shared_1.ResponsiveComponentBase);

exports.Carousel = Carousel;
exports.default = shared_1.InjectedStyledComponent(Carousel, Carousel_meta_1.CAROUSEL_CATEGORY_KEY, Carousel_meta_1.CAROUSEL_COMPONENT_KEY);